(() => {
  const dialog=document.getElementById('hp-signup-dialog');
  if(!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready='true';
  const words=JSON.parse(document.getElementById('hp-offer-words').textContent);
  const floating=document.querySelector('.hp-offer-float');
  let opener;
  try { floating.hidden=sessionStorage.getItem('hp-offer-dismissed')==='yes'; } catch { floating.hidden=false; }
  document.querySelectorAll('[data-hp-signup]').forEach(button=>button.addEventListener('click',()=>{
    opener=button;
    if(!dialog.open) dialog.showModal();
  }));
  dialog.querySelector('.hp-offer-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>opener?.focus());
  document.querySelector('.hp-offer-dismiss').addEventListener('click',()=>{
    floating.hidden=true;
    try { sessionStorage.setItem('hp-offer-dismissed','yes'); } catch {}
  });
  const result=dialog.querySelector('[data-hp-form-result]');
  if(result){
    dialog.showModal();
    if(result.dataset.hpFormResult==='success'){
      floating.hidden=true;
      try { sessionStorage.setItem('hp-offer-dismissed','yes'); } catch {}
    }
  }
  dialog.querySelector('.hp-copy-code')?.addEventListener('click',async()=>{
    try {
      await navigator.clipboard.writeText(document.getElementById('hp-offer-code').textContent);
      document.getElementById('hp-copy-status').textContent=words.copied;
    } catch { document.getElementById('hp-copy-status').textContent=words.copy_error; }
  });
})();
